export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/d9f26165e744ef064b81249371ce3c44.svg";